export default __webpack_public_path__ + "static/media/logomini.ce48c61c.png";